import React from 'react';
import { PropTypes } from 'prop-types';
import { useSelector } from 'react-redux';

const EvidentiaryDocs = ({ input, className }) => {
  const documentTypes = useSelector(state => state.auth.settings.supportingDocTypes);
  return (
    <div>
      <select value={ input.value } className={ className } onChange={ (e) => { input.onChange(e, e.target.value); } } aria-label="Supporting Document Type">
        <option value="" disabled>Choose a document type</option>
        { documentTypes.map(item => <option key={ item.key } value={ item.key }>{ item.value }</option>) }
      </select>
    </div>
  );
};

EvidentiaryDocs.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
  }).isRequired,
  className: PropTypes.string
};

EvidentiaryDocs.defaultProps = {
  className: ''
};

export default EvidentiaryDocs;
